import { appFetch } from './fetch';
import host from './host';
import auth from './auth';

export const getWarehouse  = async () => {
    const url = `${host}/warehouses/get_all`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};

export const createWarehouse = async data => {
    const url = `${host}/warehouse/create`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'POST' })
}

export const updateWarehouse = async (id, data) => {
    const url = `${host}/warehouse/update/${id}`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'PUT' })
}